<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        >
            <v-tab>Warranty Claim Information</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="form">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Customer" rules="required">
                                                <v-autocomplete
                                                    v-model="form.customer"
                                                    :items="customers"
                                                    :loading="isLoading"
                                                    :search-input.sync="search"
                                                    label="Search Customer"
                                                    hide-no-data
                                                    hide-selected
                                                    item-text="label"
                                                    item-value="value"
                                                    placeholder="Start typing to Search"
                                                    return-object
                                                    required
                                                    :error-messages="errors"
                                                    class="customer-autocomplete"
                                                    @change="assignData"
                                                ></v-autocomplete>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Customer Name" rules="required">
                                                <v-text-field
                                                v-model="form.customer_name"
                                                :error-messages="errors"
                                                label="Customer Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                <v-text-field
                                                v-model="form.street_address"
                                                :error-messages="errors"
                                                label="Street Address"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                <v-text-field
                                                v-model="form.city"
                                                :error-messages="errors"
                                                label="City"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="State" rules="required">
                                                <v-select
                                                    v-model="form.state"
                                                    :items="states"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="Select a State"
                                                    data-vv-name="state"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                <v-text-field
                                                v-model="form.zip"
                                                :error-messages="errors"
                                                label="Zip Code"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                           <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                                                <v-text-field
                                                v-model="form.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                <v-text-field
                                                v-model="form.phone"
                                                :error-messages="errors"
                                                label="Phone"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Equipment Type" rules="required">
                                                <v-text-field
                                                v-model="form.equipment_type"
                                                :error-messages="errors"
                                                label="Equipment Type"
                                                required
                                                autocomplete="equipment_type"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Model" rules="required">
                                                <v-text-field
                                                v-model="form.model"
                                                :error-messages="errors"
                                                label="Model"
                                                required
                                                autocomplete="model"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Ser#" rules="required">
                                                <v-text-field
                                                v-model="form.serial_number"
                                                :error-messages="errors"
                                                label="Ser#"
                                                required
                                                autocomplete="serial_number"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Installer" rules="required">
                                                <v-text-field
                                                v-model="form.installer"
                                                :error-messages="errors"
                                                label="Installer"
                                                required
                                                autocomplete="installer"
                                                ></v-text-field>
                                            </ValidationProvider>                                            
                                            <v-menu
                                                v-model="menu1"
                                                :close-on-content-click="false"
                                                max-width="290"
                                                >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <ValidationProvider v-slot="{ errors }" name="Date Installed" rules="required">
                                                        <v-text-field
                                                        :value="computedDateFormattedMomentjs"
                                                        clearable
                                                        label="Date Installed"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click:clear="form.date_installed = null"
                                                        required
                                                        :error-messages="errors"
                                                        ></v-text-field>
                                                    </ValidationProvider>
                                                </template>
                                                <v-date-picker
                                                    v-model="form.date_installed"
                                                    @change="menu1 = false"
                                                ></v-date-picker>
                                            </v-menu> 
                                            <ValidationProvider v-slot="{ errors }" name="Workorder No" rules="required">
                                                <v-text-field
                                                v-model="form.wo_no"
                                                :error-messages="errors"
                                                label="Workorder No"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>                                           
                                            <ValidationProvider v-slot="{ errors }" name="Defective Reason" rules="required">
                                                <v-textarea
                                                    v-model="form.defective_reason"
                                                    :error-messages="errors"
                                                    label="Defective Reason"
                                                    required
                                                    auto-grow
                                                ></v-textarea>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>                                   
                        <v-btn large min-width="100%" color="primary" tile @click="submit" :loading="loading">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import axios from 'axios'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    data () {
        return {
            tab: null,
            menu1: false,
            loading: false,
            form: {
                customer: {
                    label: '',
                    value: '',
                    object: []
                },
                customer_name: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                email: '',
                phone: '',
                equipment_type: '',
                model: '',
                serial_number: '',
                installer: '',
                date_installed: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
                wo_no: '',
                defective_reason: ''
            },
            customers: [],
            isLoading: false,
            search: null,
        }
    },
    watch: {
        search (val) {
            // Items have already been requested
            if (this.isLoading) return

            this.isLoading = true

            axios.get('crm/customers/search', {
                params: {
                    keyword: val
                }
            })
            .then(response => {
                this.customers = response.data.customers
                this.isLoading = false
                this.$nextTick()
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => (this.isLoading = false))
        },

    },
    computed: {
        ...mapGetters({
            states: 'data/states',
        }),
        computedDateFormattedMomentjs () {
            return this.form.date_installed ? moment(this.form.date_installed).format('MM-DD-yyyy') : ''
        },
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        ...mapActions({
            submitClaim: 'data/submitClaim'
        }),
        assignData() {
            this.form.customer_name = this.form.customer.object.title
            this.form.street_address = this.form.customer.object.street_address
            this.form.city = this.form.customer.object.city
            this.form.state = this.form.customer.object.state
            this.form.zip = this.form.customer.object.zip
            this.form.phone = this.form.customer.object.phone
            this.form.email = this.form.customer.object.email
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.submitClaim(this.form).then(response => {
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', response.msg)
                    this.loading = false
                    this.$refs.form.reset()
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
    }
}
</script>
<style lang="sass" scoped>
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
</style>